import './product-block.scss';

export default () => {
	let $js_product_block = $( '.js-product-block' );
	let $product_block__paragraph = $( '.product-block__paragraph' );

	$js_product_block.click( function () {
		$js_product_block.removeClass( 'active' );
		$( this ).addClass( 'active' );

		$product_block__paragraph.removeClass( 'active' );
		$product_block__paragraph.eq( $js_product_block.index( this ) ).addClass( 'active' );

		return false;
	} );
};
